// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon__3j7mQ","iconUp":"iconUp__2wJmB","iconDown":"iconDown__37ENW"};